module.exports = __webpack_public_path__ + "img/product3.64bdea32.png";